"use client";

import React from "react";

/**
 * Tab row under the home page title: "Zadnje osmrtnice | V zadnjih dneh | ...".
 * `tabs` is [{ id, label }]. The active tab is blue and underlined. With `hideActive` (phones) the
 * open tab is left out, because it is already written as the title above; the others stay.
 */
export default function HomeTabs({ tabs, activeId, onChange, hideActive = false }) {
  const visibleTabs = tabs.filter((tab) => tab && !(hideActive && tab.id === activeId));
  if (visibleTabs.length < (hideActive ? 1 : 2)) return null;

  return (
    <div
      role="tablist"
      aria-label="Prikaz osmrtnic"
      className="flex items-center justify-center text-[16px] leading-6 font-light font-variation-customOpt16"
    >
      {visibleTabs.map((tab, index) => {
        const isActive = tab.id === activeId;
        return (
          <React.Fragment key={tab.id}>
            {index > 0 && (
              <span aria-hidden="true" className="px-[18px] text-[#C7C7C7]">
                |
              </span>
            )}
            <button
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(tab.id)}
              className={`bg-transparent p-0 cursor-pointer ${
                isActive
                  ? "text-[#0A85C2] underline"
                  : "text-[#1E2125] hover:text-[#0A85C2]"
              }`}
            >
              {tab.label}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
